export const SERVICES_TITLE="SERVICES_TITLE";
export const SERVICES_SUBTITLE="SERVICES_SUBTITLE";